import React from 'react';
import { Store, ChevronRight } from 'lucide-react';
import { Card } from '../../../../components/ui/card';
import { useNavigate } from 'react-router-dom';
import { useLots } from '../../../../contexts/LotsContext';

export function CatalogWidget() {
  const navigate = useNavigate();
  const { catalogStatus } = useLots();
  const isOnline = catalogStatus?.isOnline ?? true; // Por defecto online si no hay estado

  return (
    <Card className="p-4">
      <button
        onClick={() => navigate('/catalog')}
        className="w-full flex items-center justify-between text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700/50 rounded-lg transition-colors"
      >
        <div className="flex items-center gap-3">
          <Store className="h-5 w-5 text-gray-500" />
          <div className="flex items-center gap-2">
            <span className="font-medium">Catálogo Digital</span>
            <div className={`w-2 h-2 rounded-full ${isOnline ? 'bg-green-500 animate-pulse' : 'bg-red-500'}`} />
          </div>
        </div>
        <ChevronRight className="h-5 w-5 text-gray-400" />
      </button>
    </Card>
  );
} 